import { TEventDataInput } from '@/core/constants/event_types/additional_types';
import { ShpyCpxHandlerInput } from '@/sources/bundles/wtag-shpfy-cpx/shopify_custom_pixel_types/cpx_payload_types';

import { convertCpxTimestamp } from './timestamp';

/**
 * Adds CPX event metadata (timestamp and event ID) to event data
 * @param eventData - The event data to add metadata to
 * @param cpx_input_payload - The CPX input payload containing metadata
 * @returns Event data with added metadata
 */
export function addCpxEventMetadata(
  eventData: TEventDataInput | undefined,
  cpx_input_payload: ShpyCpxHandlerInput,
): TEventDataInput {
  const { eventTimestamp } = convertCpxTimestamp(
    cpx_input_payload.event.timestamp,
  );

  if (eventData) {
    return {
      ...eventData,
      cpx_event_id: cpx_input_payload.event.id,
      timestamp: eventTimestamp,
    };
  }

  return {
    cpx_event_id: cpx_input_payload.event.id,
    timestamp: eventTimestamp,
  };
}
